// Clinical Trials Dialog Handler
// Opens Clinical Trials dialog when accordion row with data-clinical-trials-dialog is clicked

document.addEventListener('DOMContentLoaded', () => {
  // Find all Clinical Trials accordion rows
  const clinicalTrialsAccordions = document.querySelectorAll('[data-clinical-trials-dialog]');
  
  if (clinicalTrialsAccordions.length === 0) return;

  /**
   * Opens the Clinical Trials dialog for a specific accordion
   * @param {HTMLElement} accordion - The accordion element with data-clinical-trials-dialog
   * @param {HTMLElement} triggerElement - The element that triggered the dialog
   */
  function openDialog(accordion, triggerElement) {
    const dialogId = accordion.getAttribute('data-clinical-trials-dialog');
    if (!dialogId) return;
    
    const dialog = /** @type {HTMLDialogElement | null} */ (
      document.getElementById(`ClinicalTrialsDialog-${dialogId}`)
    );
    
    if (!dialog) {
      console.warn(`Clinical Trials dialog not found for ID: ${dialogId}`);
      return;
    }
    
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      
      // Hide sticky add to cart when dialog is open
      const stickyCart = document.querySelector('.sticky-add-to-cart');
      if (stickyCart) {
        stickyCart.setAttribute('aria-hidden', 'true');
      }
      
      // Focus the close button for accessibility
      const closeBtn = /** @type {HTMLElement | null} */ (
        dialog.querySelector(`[data-clinical-trials-close][data-dialog-id="${dialogId}"]`)
      );
      if (closeBtn) {
        closeBtn.focus();
      }
    }
  }

  // Handle accordion click to open dialog
  clinicalTrialsAccordions.forEach((accordion) => {
    const details = accordion.querySelector('details');
    const summary = accordion.querySelector('summary');
    
    if (!details || !summary) return;
    
    // Prevent default accordion expansion by intercepting toggle
    details.addEventListener('toggle', (event) => {
      // If trying to open, prevent it and open dialog instead
      if (details.open) {
        // Use setTimeout to allow the event to process, then close and open dialog
        setTimeout(() => {
          details.open = false;
          openDialog(accordion, summary);
        }, 0);
      }
    }, { passive: true });
    
    summary.addEventListener('click', (event) => {
      // Prevent default accordion behavior
      event.preventDefault();
      event.stopPropagation();
      
      // Open the dialog (details will try to open but toggle event will close it)
      openDialog(accordion, summary);
    });
    
    // Handle keyboard navigation
    summary.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        
        openDialog(accordion, summary);
      }
    });
  });

  // Handle dialog close events for all Clinical Trials dialogs
  document.querySelectorAll('.clinical-trials-dialog').forEach((dlg) => {
    const dialog = /** @type {HTMLDialogElement} */ (dlg);
    const dialogId = dialog.getAttribute('data-clinical-trials-dialog');
    
    if (!dialogId) return;
    
    dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (dialog.open) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      
      // Show sticky add to cart again when dialog closes
      // Find the sticky cart component and trigger its scroll handler to re-evaluate visibility
      const stickyCartComponent = document.querySelector('sticky-add-to-cart-component');
      if (stickyCartComponent && typeof stickyCartComponent.handleScroll === 'function') {
        // Re-evaluate visibility based on current scroll position
        stickyCartComponent.handleScroll();
      }
      
      // Return focus to the accordion that opened this dialog
      const activeAccordion = document.querySelector(`[data-clinical-trials-dialog="${dialogId}"] summary`);
      if (activeAccordion) {
        setTimeout(() => {
          /** @type {HTMLElement} */ (activeAccordion).focus();
        }, 0);
      }
    });

    // Handle backdrop clicks (clicking outside the dialog)
    dialog.addEventListener('click', (event) => {
      const target = /** @type {HTMLElement | null} */ (event.target);
      if (target === dialog) {
        // Clicked on the backdrop - close the dialog
        event.stopPropagation();
        if (dialog.open) {
          dialog.close();
        }
      }
    });
  });

  // Handle Escape key for dialog close
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const target = /** @type {HTMLElement | null} */ (event.target);
      const openDialog = /** @type {HTMLDialogElement | null} */ (
        target?.closest('.clinical-trials-dialog')
      );
      
      if (openDialog && openDialog.open) {
        event.preventDefault();
        event.stopPropagation();
        openDialog.close();
      }
    }
  });
});

export {};

